import Cookies from "js-cookie";
import api from "../api/api-list/index";
const moment = require("moment");
import { updateJWT } from "../assets/js/utils";

//获取jwt里边的参数
export const getTUser = () => {
  let t_user = {};
  let _t = Cookies.get("_t") || Cookies.get("_t_plugin");
  if (_t) {
    try {
      let tokenPayload = _t && JSON.parse(window.atob(_t.split(".")[1]));
      t_user = tokenPayload.User;
    } catch (error) {}
  }
  return t_user;
};

export const wxMiniAutoLogin = async () => {
  try {
    const ua = window.navigator.userAgent;
    const isWxMini =
      ua.includes("MicroMessenger") && ua.includes("miniProgram"); // 是否微信小程序

    if (!isWxMini) return;

    const urlParams = new URLSearchParams(window.location.search);
    const unionid = urlParams.get("miniprogram_unionid");
    const jwt = urlParams.get("miniprogram_cc");

    if (unionid) {
      const res = await api.auth.miniprogramAutoLogin({
        unionid,
        app_type: "mini",
      });
      if (res.code === 1000) {
        updateJWT({
          jwt: res.data.jwt,
          jwt_timestamp: res.data.jwt_timestamp,
          cookieEndTime: moment().add(14, "d").valueOf(),
        });
      }
    } else if (jwt) {
      updateJWT({
        jwt: jwt,
        jwt_timestamp: moment().valueOf(),
        cookieEndTime: moment().add(14, "d").valueOf(),
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const navigateToWebView = (url, callback) => {
  if (!url) return;

  const ua = window.navigator.userAgent;
  const isWxMini = ua.includes("MicroMessenger") && ua.includes("miniProgram"); // 是否微信小程序

  if (isWxMini && window.wx) {
    const path = url.includes('http') ? `/pages/campaign/campaign?src=${encodeURIComponent(url)}` : url
    window.wx.miniProgram.navigateTo({
      url: path,
    });
  } else {
    if (callback) return callback();
    window.location.href = url;
  }
};

export const switchToWebView = (url, callback) => {
  if (!url) return;

  const ua = window.navigator.userAgent;
  const isWxMini = ua.includes("MicroMessenger") && ua.includes("miniProgram"); // 是否微信小程序

  if (isWxMini && window.wx) {
    window.wx.miniProgram.switchTab({
      url,
    });
  } else {
    if (callback) return callback();
    window.location.href = url;
  }
};

export const redirectToWebView = (url, callback) => {
  if (!url) return;

  const ua = window.navigator.userAgent;
  const isWxMini = ua.includes("MicroMessenger") && ua.includes("miniProgram"); // 是否微信小程序

  if (isWxMini && window.wx) {
    const path = url.includes('http') ? `/pages/campaign/campaign?src=${encodeURIComponent(url)}` : url
    window.wx.miniProgram.redirectTo({
      url: path,
    });
  } else {
    if (callback) return callback();
    window.location.replace(url);
  }
}